export const slug = "client-detail";
export const title = "Client Detail";
export const section = "Core";
export const content = `
# Client Detail

The Client Detail page shows everything about a single client and lets staff manage their record.

## Editing the Profile

Click **Edit** in the profile card to update name, address, phone, and email. Save with the **Save** button or press Escape to cancel. Changes are logged in the audit trail automatically.

## Household Members

The **Household** section lists everyone living at the same address and sharing the client's benefits. Use **Add Member** to register a new household member, or click an existing member to edit their info. Household size affects eligibility tiers in programs like Sharing Tree.

## Visit History

The **Visit History** tab shows every Saturday distribution the client has participated in. Each row shows the date, items received, and the staff member who checked them in.

### Backfilling Visits

If a client was served but the visit was not recorded in real time, use **Add Past Visit** to backfill. Select the date, record items, and save. Backfilled visits are flagged with a pencil icon so auditors can distinguish them from live check-ins.

## Adding to the Queue

The **Add to Queue** button places the client into today's Saturday queue without requiring them to check in via the kiosk. Use this for clients who arrive without a phone or who need assisted check-in.

## Kiosk Visibility Toggle

The **Show on Kiosk** toggle controls whether this client can see their position in the queue on the waiting-room kiosk display. Disable it for clients who prefer privacy.

## Phone & Email Flags

If a phone number returned a bounce or an email was marked undeliverable, a **flag icon** appears next to the contact info. Click the flag to clear it after verifying the correct contact with the client.
`;
